import { Translations } from './Translations';

export const nl: Translations = {
  // #region simple strings
  accept: 'Aanvaarden',
  accepted_user_agreements: 'Geaccepteerde gebruikersovereenkomsten',
  account_expired: 'Account verlopen',
  account_setup: 'Instellen van een account',
  accountability_date: 'Startdatum',
  achieved: 'Behaald',
  active: 'Actief',
  active_status: 'Actief status',
  add: 'Voeg toe',
  add_action: '{addee} toevoegen',
  add_lti_data: 'LTI gegevens toevoegen?',
  add_page: 'Voeg pagina toe',
  add_practice_test: 'Voeg oefentoets toe',
  add_final_test: 'Voeg afrondende toetsing toe',
  add_profile: 'Voeg profiel toe',
  add_profiles: 'Voeg profiel toe',
  add_team: 'Voeg team toe',
  add_theme: 'Voeg thema toe',
  add_themes_to_articles: `Thema's toevoegen aan artikel`,
  add_themes_to_profiles: `Thema's toevoegen aan profiel`,
  add_to_main_team: 'Toevoegen aan het hoofdteam',
  add_users_to_team: 'Gebruikers toevoegen aan team',
  add_users: 'Gebruikers toevoegen',
  all_articles: 'Alle artikelen',
  all_users: 'Alle gebruikers',
  already_assigned_to_this_user: 'Al toegewezen aan deze gebruiker',
  article_management: 'Artikelbeheer',
  article_published_successfully: 'Artikel succesvol gepubliceerd',
  article_published: 'Artikel gepubliceerd',
  article_not_yet_published: 'Nog niet gepubliceerd',
  article: 'Artikel',
  application: 'Applicatie',
  imported: 'Geïmporteerd op',
  user_activity: 'Gebruikersactiviteit',
  none: 'Geen',
  article_content: {
    page_title: 'Artikel aanmaken',
    content: 'Inhoud',
    chapter: 'hoofdstuk',
    option: 'optie',
    page: 'pagina',
    question: 'vraag',
    answer: 'antwoord',
    exam_questions: 'toetsvragen',
    number_of_questions: 'aantal vragen per poging',
    number_of_questions_hint: 'Er worden per poging willekeurig {asked} van de {total} vragen gekozen',
    success_treshold: 'Slaaggrens (%)',
    is_correct: 'Juiste antwoord',
    final_test: 'Eindtest',
    start_final_test: 'Start de eindtest',
    retake_exam: 'Examen herkansen',
    final_test_completed_title: 'Eindtest succesvol afgerond',
    score_saved: 'Je score is opgeslagen.',
    exam_completed: '% examen afgerond'
  },
  user_article: {
    final_test: 'eindtest',
    success: 'geslaagd',
    fail: 'Wat jammer!',
    result: 'Resultaat van de eindtest',
    retake: 'Opnieuw',
    submit_final_test: 'Eindtest afronden',
    submit_test: 'Indienen',
    subtext_fail: 'Je bent niet geslaagd voor de test. Je kunt hieronder je antwoorden bekijken.',
    subtext_pass: 'Gefeliciteerd! Je bent geslaagd voor de test. Je kunt hieronder je antwoorden bekijken.',
    grade: 'Uw cijfer: ',
    passing_grade: 'Geslaagd cijfer: ',
  },
  articles: {
    article: 'Artikel',
    articles: 'Artikelen',
    cannot_edit_global_article: 'Globaal artikel kan niet worden bewerkt',
    number_of_articles: 'Aantal artikelen',
    attachments: 'Bijlagen',
    uploaded_files: 'Geüploade bestanden',
    import_failed: 'Importeren van de artikelbijlage is mislukt.',
    import_success: 'Importeren van de artikelbijlage is geslaagd',
    attachments_modal_msg: 'Hier kunt u bijlagen voor dit artikel uploaden. U kunt op elk moment de bestandslink kopiëren of bestanden verwijderen.',
    attachments_modal_warning: 'Zorg ervoor dat de bijlage niet in het artikel wordt gebruikt voordat je deze verwijdert.',
    add_attachment: 'Bijlage toevoegen',
    link_copied: 'Link gekopieerd naar het klembord',
    no_files_attached: 'Geen bestanden bijgevoegd',
    attachment: 'Bijlage',
    published: 'Gepubliceerd',
    content: 'Inhoud',
    specialist: 'Specialist',
    edit_article: 'Artikel bewerken',
    edit_content: 'Inhoud bewerken',
    create_content: 'Inhoud maken',
    published_info: 'Je moet inhoud maken en een thema toevoegen om dit artikel te kunnen publiceren',
    article_created: 'Artikel gemaakt',
    article_created_success: 'Artikel succesvol aangemaakt'
  },
  assign_profiles_to_user: 'Profielen toewijzen aan gebruiker',
  assign_themes_to_user: `Thema's toevoegen aan gebruiker`,
  assign_user_to_teams: 'Teams toevoegen aan gebruiker',
  author: 'Auteur',
  by_integration: 'Door integratie',
  cancel: 'Annuleren',
  click_on_pdf_report_to_download: `Klik op PDF rapportage' er wordt een pdf gemaakt van je rapport.`,
  company_manager: 'Bedrijfs manager',
  competencies: {
    competencies: 'Adviesbevoegdheden',
    competency: 'Adviesbevoegdheid',
    competency_already_included: 'Deze adviesbevoegdheid is al opgenomen in een andere adviesbevoegdheid',
    competency_name: 'Naam van competentie',
    create_competency: 'Nieuwe adviesbevoegdheid',
    delete_competency: 'Competentie verwijderen',
    module_actions_disabled: 'Deze adviesbevoegdheid is automatisch gegenereerd. U kunt geen modules toevoegen of verwijderen.',
    multiple_competencies: 'Meerdere competenties',
    no_optional_competencies_assigned: 'No optional competencies assigned',
    no_required_competencies_assigned: 'No required competencies assigned',
    source: 'Bron',
    manually_created: 'Handmatig',
    system_defined: 'Systeem',
    cannot_delete_sys_competency: 'Systeemgedefinieerde competentie kan niet worden verwijderd',
    requirement: 'Vereiste',
    expiry_date: 'Vervaldatum',
    required: 'Verplicht',
    optional: 'Optioneel',
    passed: 'Geslaagd',
    not_completed: 'Niet voltooid',
    pe_status: 'PE Status',
    competency_sys_defined: 'Competentie is door het systeem aangemaakt.',
    assigned_to_employees: 'Competentie is toegewezen aan medewerkers.',
    dependent_competency: 'Competentie heeft afhankelijke competenties.'
  },
  competencies_modules_form: {
    choose_unique_name: 'Kies een unieke naam',
    create_competency_modules_note: 'Na het aanmaken van de adviesbevoegdheid kunt u modules toevoegen',
    scope: 'Scope',
    scopes: {
      global: 'Globaal',
      company_specific: 'Bedrijf specifiek',
    }
  },
  completed: 'Behaald',
  confirm: 'Bevestigen',
  create_and_edit_article: 'Artikel aanmaken en aanpassen',
  create_and_edit_article_content: 'Artikel inhoud aanmaken en aanpassen',
  create_article: 'Artikel aanmaken',
  create_employee: 'Maak gebruiker aan',
  create_employer: 'Maak werkgever aan',
  create_profile: 'Profiel aanmaken',
  create_team: 'Team aanmaken',
  create_theme: 'Thema aanmaken',
  creation_date: 'Aanmaakdatum',
  current_team: 'Huidig team',
  custom_settings: 'Aangepaste instellingen',
  dashboard: 'Dashboard',
  default_settings: 'Standaard instellingen',
  date: 'Datum',
  delete: 'Verwijderen',
  delete_action: {
    title: 'Verwijder {deletee}',
    message: 'Weet u zeker dat je het {deletee} wilt verwijderen?',
    success_title: '{deletee} verwijderd!',
    success_message: 'U heeft deze {deletee} succesvol verwijderd.',
  },
  delete_article: 'Artikel verwijderen',
  delete_article_message: 'Weet u zeker dat je het artikel wilt verwijderen',
  delete_employee: 'Verwijder gebruiker',
  delete_employee_message: 'Weet u zeker dat u deze gebruiker wilt verwijderen?',
  delete_employee_success_title: 'Gebruiker verwijderd',
  delete_employee_success_message: 'U heeft deze gebruiker succesvol verwijderd.',
  delete_employer: 'Verwijder werkgever',
  delete_employer_message: 'Weet u zeker dat u deze werkgever wilt verwijderen?',
  delete_employer_success_title: 'Werkgever verwijderd',
  delete_employer_success_message: 'U heeft deze werkgever succesvol verwijderd.',
  delete_hover_message: 'Alleen inactieve gebruikers kunnen worden verwijderd',
  delete_message: 'Weet u zeker dat je het {deletee} wilt verwijderen',
  delete_profile: 'Verwijder profiel',
  delete_profile_message: 'Weet u zeker dat je het profiel wilt verwijderen',
  delete_team: 'Verwijder team',
  delete_team_message: 'Weet je zeker dat je het team wilt verwijderen',
  delete_theme: 'Verwijder thema',
  delete_theme_message: 'Weet je zeker dat je het thema wilt verwijderen',
  delete_title: 'Verwijder {deletee}',
  description: 'Beschrijving',
  disabled: 'Uitgeschakeld',
  download_step_by_step_instructions: 'Download stap voor stap instructies',
  details: 'Details',
  edit_article: {
    content: 'Content aanpassen',
    details: 'Details aanpassen',
    title: 'Artikel aanpassen',
    subtitle: 'Artikel inhoud aanmaken en aanpassen',
    main_description:
      'Inhoud van artikelen zonder LTI-identificatie kan worden gemaakt in ons platform op de gerelateerde update-inhoudspagina. Klik hieronder om te beginnen.',
    main_description_lti:
      "Om een artikel aan te maken heb je eerst de LTI Identifier nodig, deze kan je aanmaken in SkillsTown. Een artikel inhoudelijk aanpassen kan hier ook gedaan worden. Klik op 'Open SkillsTown' om een LTI Identifier te krijgen of een artikel aan te passen.",
    button_to_content_editor: 'Inhoud toevoegen of bewerken',
    save_lti_first:
      'De LTI-identifier bepaalt het platform waarop u de artikelinhoud kunt bewerken. Sla de wijzigingen in de artikeldetails op om toegang te krijgen tot het juiste platform.',
  },
  edit_employee: 'Gebruiker aanvullen',
  edit_employer: 'Werkgever aanpassen',
  edit_profile: 'Profiel aanpassen',
  edit_team: 'Team aanpassen',
  edit_theme: 'Thema aanpassen',
  edit_user: 'Gebruikersgegevens aanpassen',
  email: 'E-mailadres',
  enabled: 'Ingeschakeld',
  identity_provider: 'Identiteitsprovider',
  provider_name: 'Naam van de provider',
  sso: 'Single Sign-On',
  login_url: 'Login-URL',
  copy_link: 'Link kopiëren',
  color_green: 'groen',
  color_orange: 'oranje',
  color_red: 'rood',
  employee: {
    import: 'Import',
    import_teams: 'Teams importeren',
    import_teams_success: '{createdNr} teams aan medewerkers gekoppeld. {updatedNr} reeds aanwezig.',
    import_success: 'Importeren gelukt',
    import_failed: 'Kan Teams niet importeren', 
    import_pa: 'PA importeren',
    import_pe: 'PE importeren',
    import_employees: 'Werknemers importeren',
    assign_competencies_to_user: 'Voeg adviseurschap toe aan gebruiker',
    add_competency: 'Voeg adviseurschap toe',
    index: 'Gebruiker',
    no_competencies_found: 'Geen adviseurschappen gevonden',
    optional_competencies: 'Optionele adviseurschappen',
    required_competencies: 'Verplichte adviseurschappen',
    update_accountability_date: 'Update startdatum',
    update_accountability_date_desc: 'Werk hieronder de startdatum van de gebruiker bij.',
    update_accountability_date_validation_error:
      'U moet een datum selecteren om de startdatum bij te werken.',
    competence: 'Competentie',
    themes_decreased: 'Optionele themas {themes} zijn verwijderd, omdat ze onderdeel zijn van het profiel {profile} dat is toegevoegd.',
    cannot_edit_tripleadmin: 'Triple Admin kan niet worden bewerkt',
    send_welcome_email: 'Verstuur welkomstmail',
    email_pending: 'Welkomstmail is in behandeling.',
    email_not_sent: 'Welkomstmail is niet verzonden.',
    email_failed_to_be_sent: 'Verzenden van de welkomstmail is mislukt.',
    pending: 'In behandeling',
    sent: 'Verzonden',
    failed: 'Mislukt',
    not_sent: 'Niet verzonden',
    send_welcome_email_dialog_title: 'Welkomstmail versturen',
    send_welcome_email_dialog_message: 'Weet je zeker dat je de welkomstmail wilt versturen?',
    welcome_email_sent_snackbar_title: 'De activatielink-e-mail wordt verzonden',
    welcome_email_sent_snackbar_message: 'De activeringslink e-mail is in de wachtrij geplaatst en wordt binnenkort verzonden.',
    welcome_email_status: 'Status van de welkomstmail',
    employee_creation_in_progress: 'De medewerker wordt aangemaakt'
  },
  employees: 'Gebruikers',
  qualifications: {
    index: 'Kwalificaties',
    type: 'Type',
    uploaded_at: 'Upload datum',
    validated_at: 'Validatiedatum',
    validation_status: 'Validatiestatus',
    qualification_type_none: 'Geen',
    qualification_type_diploma: 'Diploma',
    qualification_type_extension: 'Verlenging',
    generating_pdf: 'PDF genereren..',
    status: {
      all: 'Alle',
      awaiting_validation: 'Wacht op validatie',
      rejected: 'Afgekeurd',
      approved: 'Goedgekeurd',
    },
    validation: {
      validate_qualification: 'Valideer kwalificatie voor competentie',
      download_info: 'Download de kwalificatie als je dat nog niet hebt gedaan',
      qualification_check: 'Controleer of de kwalificatie overeenkomt met de competentie',
      qualification_verify: 'Controleer of de kwalificatie echt is',
      add_exam_date: 'Voeg de examendatum toe die op de kwalificatie staat',
      select_qualification: 'Selecteer het type kwalificatie',
      qualification_type: 'Kwalificatietype',
      reject: 'Afkeuren',
      approve: 'Goedkeuren',
      success_validation_title: 'Kwalificatie succesvol gevalideerd',
      success_rejected_title: 'Kwalificatie succesvol afgekeurd',
      success_validation_message: 'Je wijzigingen zijn opgeslagen',
      error_validation_title: 'Fout bij kwalificatievalidatie',
      error_validation_message: 'Er is een fout opgetreden bij de kwalificatievalidatie. Neem contact op met support.'
    },
    qualifications: 'Kwalificaties',
    qualification: 'Qualification',
    upload_qualification: 'Kwalificatie uploaden',
    competence: 'Vaardigheid',
    examDate: 'Examen­datum',
    uploadAt: 'Geüpload op',
    validationStatus: 'Validatiestatus',
    validatedAt: 'Gevalideerd op',
    typeEnum: {
      none: 'Geen',
      diploma: 'Diploma',
      extension: 'Verlenging'
    },
    import: `Je staat op het punt een kwalificatie te uploaden.

        1. Selecteer de competentie waarop de kwalificatie van toepassing is
        2. Sleep het bestand naar het aangegeven gebied
        3. Klik op Opslaan

        Het bestand moet gevalideerd worden, dit kan even duren. Je kunt de status bekijken in het overzicht.`,
    import_qualifications: 'Kwalificaties importeren',
    import_qualification_success: 'Kwalificatie succesvol geïmporteerd',
    competencies_empty: "Er zijn geen competenties aan je toegewezen. Vraag je manager om een competentie toe te wijzen of selecteer zelf een optionele competentie",
    validated: 'Dit document is gevalideerd.',
    select_option: 'Selecteer een optie',
    no_options_available: 'Geen opties beschikbaar',
    qualification_reviewed: 'Kwalificatie is al beoordeeld'
  },
  certificates: {
    uploaded_at: 'Upload datum',
    validated_at: 'Validatiedatum',
    validation_status: 'Validatiestatus',
    generating_pdf: 'PDF genereren..',
    validation: {
      validate_certificate: 'Valideer certificaat voor module',
      download_info: 'Download het certificaat als je dat nog niet hebt gedaan',
      certificate_check: 'Controleer of het certificaat overeenkomt met de module',
      certificate_verify: 'Controleer of het certificaat echt is',
      add_exam_date: 'Add exam date that is written on certificate',
      reject: 'Afkeuren',
      approve: 'Goedkeuren',
      success_validation_title: 'Certificaat succesvol gevalideerd',
      success_rejected_title: 'Certificaat succesvol afgekeurd',
      success_validation_message: 'Je wijzigingen zijn opgeslagen',
      error_validation_title: 'Fout bij certificaatvalidatie',
      error_validation_message: 'Er is een fout opgetreden bij de certificaatvalidatie. Neem contact op met support.'
    },
    certificates: 'Certificaten',
    certificate: 'Certificaat',
    upload_certificate: 'Certificaat uploaden',
    module: 'Module',
    examDate: 'Examen Datum',
    uploadAt: 'Geüpload Op',
    validationStatus: 'Validatiestatus',
    validatedAt: 'Gevalideerd Op',
    import: `Je staat op het punt een certificaat te uploaden.

      1. Selecteer de module waarop het certificaat van toepassing is
      2. Sleep het bestand naar het aangegeven gebied
      3. Druk op Opslaan

      Het bestand moet worden gevalideerd, dit kan enige tijd duren. 
      Je kunt de status bekijken in het overzicht.`,
    import_certificates: 'Certificaten importeren',
    import_certificate_success: 'Certificaat succesvol geïmporteerd',
    import_certificate_failed: 'Importeren van certificaat mislukt',
    competencies_empty: 'Er zijn geen competenties aan je toegewezen. Vraag je manager om een competentie toe te wijzen of selecteer zelf een optionele competentie',
    validated: 'Dit document is gevalideerd.',
    select_option: 'Selecteer een optie',
    no_options_available: 'Geen opties beschikbaar',
    certificate_reviewed: 'Certificaat is al beoordeeld'
  },
  employees_managed_by_integration_only: 'Medewerkers worden alleen beheerd door integratie',
  employer_manage: {
    application_active: 'Application active',
    green_to_orange_message: `De PA-status geeft aan hoe goed medewerkers bijblijven met het lezen van artikelen. 
      Stel hier in vanaf hoeveel ongelezen artikelen de status oranje en rood wordt.`,
    multiple_profiles_message: `Enkele profielselectie: Eén profiel kan alleen aan een werknemer worden toegewezen als er geen andere profielen zijn toegewezen.
    Meervoudige profielselectie: Meerdere profielen kunnen aan een werknemer worden toegewezen.`,
    locked_profiles_message: 'Wanneer vergrendeld: profielen kunnen alleen door SuperAdmin worden aangepast, niet door de organisatie.',
    pa_active: 'PA is actief',
    pe_active: 'PE is actief',
    pa_feature_settings: 'Instellingen Permanent Actueel (PA)',
    pe_feature_settings: 'Instellingen Permanente Educatie (PE)',
    renewal_threshold: 'Waarschuwingstermijn voor vervaldatum (dagen) adviesbevoegdheid',
    employee_certification_upload_active: 'Uploaden van certificaten aan',
    direct_exam_active: 'Examens boeken aan',
    resend_email_with_status: 'Welkomstmails opnieuw versturen naar medewerkers met de status:',
    emails_processing: 'E-mails verwerken...',
    send_welcome_email_dialog_title: 'Welkomstmails opnieuw versturen',
    send_welcome_email_dialog_message: 'Weet je zeker dat je de welkomstmails opnieuw wilt versturen naar alle medewerkers met de status "{status}"?',
    welcome_email_sent_snackbar_title: 'Welkomstmails in de wachtrij geplaatst',
    welcome_email_sent_snackbar_message: 'De welkomstmails zijn in de wachtrij geplaatst en worden binnenkort verzonden.',
    pa_threshold_message: 'De status wordt {color} wanneer een medewerker meer dan {threshold} artikelen achterloopt',
    pa_status_at_most_message: 'PA-status {color}: De medewerker heeft maximaal {threshold} openstaande artikelen.',
    pa_status_over_message: 'PA-status {color}: De medewerker heeft meer dan {threshold} openstaande artikelen.',
    pa_single_profile_message: 'Een medewerker kan {amount} profiel toegewezen krijgen',
    pa_multiple_profiles_message: 'Een medewerker kan {amount} profielen toegewezen krijgen',
    pa_single_profile_amount: 'één',
    pa_multiple_profiles_amount: 'meerdere',
    pa_profile_editing_message: 'Profielen bewerken is {state}',
    pa_profile_editing_enabled: 'ingeschakeld',
    pa_profile_editing_disabled: 'uitgeschakeld',
    pe_renewal_threshold_message: 'Waarschuw {days} dagen voordat een adviesbevoegdheid verloopt',
  },
  employer_admin: 'Werkgever Admin',
  employer_details: 'Werkgevergegevens',
  employer_details_explanation:
    'Basisinformatie voor deze werkgever. Dit zijn de minimaal noodzakelijke gegevens die nodig zijn voor dit record.',
  employer_name: 'Werkgever naam',
  employer_specific_theme: `Bedrijfsspecifieke thema's`,
  employer_specific_profiles: 'Werkgeverspecifiek profiel',
  employer: 'Werkgever',
  employers: 'Werkgevers',
  employer_competency: {
    name: 'Naam van competentie',
    valid: 'Geldige competentie',
    nearly_expired_threshold: 'Verloopt binnen {days} dagen',
    invalid: 'Ongeldige competentie',
    sum: 'Aantal toegewezen competenties',
  },
  exam_attempts: {
    booking_status: 'Boekingsstatus',
    dashboard_title: 'Boekingsoverzicht',
    dashboard_subtitle: 'In onderstaand overzicht ziet u uw geregistreerde examens en resultaten. Wilt u direct een nieuwe examendatum vastleggen? Klik dan op Examen boeken.',
    exam_date: 'Examendatum',
    exam_grade: 'Cijfer',
    exam_result: 'Resultaat',
    booking_statuses: {
      pending: 'In afwachting',
      acknowledged: 'Bevestigd',
      cancelled: 'Geannuleerd',
      cancelled_no_charge: 'Geannuleerd zonder kosten',
      cancelled_payback: 'Geannuleerd met terugbetaling',
      cancelled_expired: 'Geannuleerd verlopen',
      closed: 'Afgesloten',
      closed_no_result: 'Afgesloten zonder resultaat',
      no_show: 'Niet verschenen',
    },
    exam_results: {
      closed: 'Gesloten',
      failed: 'Niet geslaagd',
      passed: 'Geslaagd'
    },
    booking_number: 'Boekingsnummer',
    booking_location: 'Boekingslocatie',
    import_booking: 'Boeking importeren',
    import_exam_result: 'Examenuitslag importeren',
    import: `U staat op het punt om {importType}-gegevens te uploaden vanuit een Excel-bestand. 
Om de juiste opmaak te garanderen, download eerst het meegeleverde sjabloon met alle vereiste kolommen.

1. Sleep het bestand naar het aangegeven gebied  
2. Klik op Opslaan  

Na de verwerking ziet u een overzicht waarin wordt aangegeven welke rijen succesvol zijn geïmporteerd en welke fouten bevatten.`,
    rows_import_success: '{createdNr} rijen toegevoegd',
    rows_import_updated: '{updatedNr} rijen bijgewerkt',
    rows_total_read: '{totalReadNr} rijen verwerkt',
    booking: 'Boeking',
    import_failed: 'Import mislukt',
    lamark_code: 'LaMark-code',
    error_report: 'Sommige rijen konden niet worden geïmporteerd. Klik {link} om het foutrapport te downloaden.'
  },
  excel_report: 'Excelrapportage',
  expiration_date: 'Toegang geldig tot',
  export_report: 'Rapport exporteren',
  export_a_report_for_the_selected_date:
    'In de rapportage staat voor de periode die je hebt geselecteerd:',
  export_employees: 'Gebruikers exporteren',
  export_options: 'Selecteer export optie',
  export: 'Exporteer',
  notes: 'Notities',
  information: 'Information',
  filter_on: 'Filter op',
  final_test: 'Afrondende toetsing',
  first_name: 'Voornaam',
  first_time_login:
    'We zien dat dit de eerste keer is dat je inlogt in Triple A, we hebben een kort overzicht van de functionaliteiten beschikbaar.',
  from: 'Vanaf',
  function_name: 'Functienaam',
  global_profiles: 'Algemeen profiel',
  general: 'Algemeen',
  global_theme: 'Algemeen thema',
  green_to_orange_pa_threshold: 'Oranje na',
  idle_text:
    'Om veiligheidsredenen wordt u vanwege inactiviteit binnen de komende vijf minuten uitgelogd bij deze applicatie. Om deze sessie te verlengen, klikt u hieronder op annuleren.',
  idle_title: 'Inactiviteitswaarschuwing',
  image: 'Afbeelding',
  item: 'Item',
  items: 'Items',
  import_employee_profiles: 'Importeer profielen',
  import_employees: 'Gebruikers importeren',
  import_employees_success: '{createdNr} medewerkers geimporteerd en {updatedNr} medewerkers aangepast.',
  import_competencies_success: 'Geïmporteerd {createdNr} competenties en {updatedNr} competenties bijgewerkt',
  import_employee_profiles_success:
  {
    part1: '{createdNr} profiel(en) aan medewerker(s) toegevoegd.',
    part2: '{updatedNr} aanpassing(en) aan reeds gekoppelde profielen uitgevoerd.',
  },
  import_employees_failed: 'De medewerkers kunnen niet worden geimporteerd:',
  import_employee_profiles_failed: 'De profielen konden niet worden geimporteerd.',
  import_competencies_failed: 'Kan competenties niet importeren',
  import_successful: 'Importeren succesvol',
  import_result: 'Importresultaat',
  import_summary: 'Importsamenvatting',
  import_field: 'Importeer bestand',
  in_progress: 'In Uitvoering',
  inactive: 'Inactief',
  include_lti_data: 'Voeg LTI gegevens toe',
  initialization: 'initialisatie',
  last_name: 'Achternaam',
  legend: 'Legenda',
  locked: 'Op slot',
  logout: 'Uitloggen',
  loose_themes: `Losse thema's`,
  lti_identifier: 'LTI identifier',
  has_lti_identifier: 'Met LTI identifier',
  manage: 'Beheren',
  modules: {
    add_module: 'Add module',
    add_modules_to_competency: 'Add modules to competency',
    la_mark_codes: 'LaMark codes',
    modules: 'Modules',
    module: 'Module',
    no_modules_found: 'No modules found',
    create_module: 'Nieuwe module',
    delete_module: 'Module verwijderen',
    module_name: 'Modulenaam',
    source: 'Bron',
    manually_created: 'Handmatig',
    system_defined: 'Systeem',

    module_sys_defined: 'Module is door het systeem gedefinieerd.',
    assigned_to_employees: 'Module is toegewezen aan medewerkers.',
    assigned_to_competencies: 'Module is toegewezen aan competenties.',
    has_exam_codes: 'Module heeft examencodes.',
    has_exam_attempts: 'Module heeft examenpogingen.'
  },
  snackbar: {
    error: 'fout',
    error_title: 'Fout tijdens {process}',
    error_custom_title: '{title}',
    error_message: '{action} niet voltooid',
    error_custom_message: '{message}',
    success: 'Succes',
    success_message_create: '{item} aangemaakt',
    success_message_update: '{item} bijgewerkt',
    success_message_delete: '{item} verwijderd',
  },
  action: {
    fetch_data: 'het ophalen van data',
    fetch_item: 'het ophalen van {item}',
    update_item: 'het bijwerken van {item}',
    validate_item: 'het valideren van {item} {index}',
  },
  multiple_profiles: 'Meerdere profielen',
  must_be_greater_than_prior_threshold:
    'Moet groter zijn dan of gelijk zijn aan de eerdere drempel',
  my_employer: 'Mijn Werkgever',
  my_profile: 'Mijn profiel',
  name: 'Naam',
  next: 'Volgende',
  no_articles: 'Geen artikelen',
  no_employees_found: 'Geen medewerkers gevonden',
  no_lti_data_needed: 'Geen LTI gegevens nodig',
  no_mandatory_profiles_assigned_to_this_user:
    'Aan deze gebruiker zijn geen verplicht profielen toegewezen.',
  no_optional_profiles_assigned_to_this_user:
    'Aan deze gebruiker zijn geen optionele profielen toegewezen.',
  no_themes_assigned_to_this_user: `Aan deze gebruiker zijn geen optionele thema's toegewezen.`,
  no: 'Nee',
  not_active: 'Niet actief',
  number_of_employees: 'Aantal medewerkers',
  of: 'van',
  optional_profiles: 'Optionele profielen',
  optional_themes: `Optionele thema's`,
  orange_to_red_pa_threshold: 'Rood na',
  pa_feature: 'Permanent Actueel',
  pa_status_per_theme: `PA Status thema's`,
  pa_status: 'PA Status',
  pa_status_options: {
    up_to_date: 'Actueel (groen)',
    up_to_date_orange: 'Actueel (oranje)',
    outdated: 'Niet actueel',
    unknown: 'Onbekend'
  },
  pa_status_label: {
    up_to_date: 'Actueel',
    outdated: 'Niet actueel',
    unknown: 'Onbekend'
  },
  unread_articles_count: '{count} ongelezen artikel | {count} ongelezen artikelen',
  pe_status: {
    index: 'PE Status',
    near_expiry: 'Bijna verlopen',
    invalid: 'Ongeldig',
    valid: 'Actueel',
    none: 'Geen',
  },
  page: 'Pagina',
  parent_team: 'Hoofdteam',
  pdf_report: 'PDF Rapport',
  pe_feature: 'Permanente Educatie (PE)',
  sso_external_id: 'Extern Id (SSO)',
  previous: 'Vorige',
  privacy_policy: 'Privacybeleid',
  profile_name: 'Profiel naam',
  profile_type: 'Profieltype',
  profile: 'Profiel',
  profiles: 'Profielen',
  profiles_company_specific: 'Bedrijf specifiek',
  profiles_global: 'Globaal',
  profiles_cannot_edit_profile: 'Dit profiel kan niet worden bewerkt',
  request_custom_profile: 'Vraag maatwerkprofiel aan',
  publication_date: 'Publicatiedatum',
  publish: 'Publiceren',
  published: 'Gepubliceerd',
  question: 'Vraag',
  report_export_information: 'Uitleg over het maken van rapportage',
  report: 'Rapport',
  reports: 'Rapporten',
  required_profiles: 'Verplichte profielen',
  required_themes: `Verplichte thema's`,
  required: 'Verplicht',
  required_or_remove: 'Vul dit verplichte veld in of verwijder het.',
  required_profiles_assigned_by_integration_only:
    'Vereiste profielen die alleen door integratie worden toegewezen',
  results: 'resultaten',
  review_and_complete_account_setup: 'Controleer en voltooi de accountconfiguratie.',
  review_and_submission: 'Beoordeling en indiening',
  role: 'Rol',
  run_excel_report: 'Excelrapportage maken',
  save: 'Save',
  save_article: 'Artikel opslaan',
  save_changes: 'Wijzigingen opslaan',
  save_employee: 'Gebruiker opslaan',
  save_employer: 'Werkgever opslaan',
  save_profile: 'Profiel opslaan',
  save_team: 'Team opslaan',
  save_theme: 'Thema opslaan',
  save_user: 'Gebruiker opslaan',
  search: 'Zoeken',
  select_a_jpeg_or_png_from_your_device: 'Selecteer een .jpeg- of .png-bestand op uw apparaat.',
  service_alerts: {
    service_alerts: 'Servicemeldingen',
    service_alert: 'servicemelding',
    create_notification: 'Melding aanmaken',
    message: 'Bericht',
    active_from: 'Actief vanaf',
    duration: 'Duur',
    duration_in_hours: 'Duur (uren)',
    duration_placeholder: 'Aantal uren',
    created_by: 'Aangemaakt door',
    notifications: 'Meldingen',
    no_notifications: 'Geen meldingen',
  },
  settings: 'Instellingen',
  setup_account: 'Account aanmaken',
  show_employer_settings: 'Toon werkgeversinstellingen',
  show_lti_options: 'Toon LTI opties',
  specialist: 'Specialist',
  status: 'Status',
  single_profile: 'Enkel profiel',
  support: 'Ondersteuning',
  takeme_to_app: 'Verder naar Triple A',
  takeme_to_functionalities: 'Overzicht functionaliteiten',
  team_name: 'Team naam',
  team: 'Team',
  teams: 'Teams',
  terms_and_conditions: 'Algemene voorwaarden',
  test_passed: 'Test geslaagd',
  test: 'Test',
  theme_name: 'Naam thema',
  number_of_unread_articles: 'Aantal ongelezen artikelen',
  theme_type: 'Thematype',
  theme_types: {
    global: "Algemene thema's",
    company: "Bedrijfsspecifieke thema's",
  },
  theme: 'Thema',
  themes: {
    themes: `Thema's`,
    cannot_edit_global_theme: 'Algemeen thema kan niet worden bewerkt',
    global: 'Algemeen',
    number_of_themes: `Aantal thema's`
  },
  through_application: 'Via applicatie',
  this_user_is_not_a_member_of_any_team: 'Deze gebruiker is geen lid van een team.',
  title: 'Titel',
  to_admin_panel: 'Naar beheersomgeving',
  to_article_manager: 'Naar Artikelbeheer',
  to_teams_overview: 'Naar teams overzicht',
  to_user_panel: 'Naar gebruikersomgeving',
  to: 'Tot',
  topics_youve_viewed: `Verplichte profiel wat is toegewezen`,
  triple_admin: 'Triple Admin',
  unknown_error: 'Onbekende fout',
  unknown_error_message:
    'Er is een onbekende fout opgetreden. Probeer het opnieuw. Neem contact op met support als de fout aanhoudt.',
  unknown: 'Onbekend',
  unlocked: 'Ontgrendeld',
  unread: 'Ongelezen',
  unmanaged_employer_settings_explanation:
    'Deze instellingen kunnen niet via dit beheerdersdashboard worden beheerd, maar worden hier ter referentie vermeld.',
  update_article_content: 'Artikelinhoud bewerken',
  user_competencies: {
    delete_user_competency_message: 'Weet u zeker dat je het adviesbevoegdheidwilt verwijderen? Deze actie verwijdert ook alle geüploade kwalificaties en certificaten.',
    expired: 'Verlopen sinds',
    manage_profiles_and_themes: 'Manage profiles and themes',
    modules: 'Modules',
    not_qualified: 'Niet gekwalificeerd',
    valid_until: 'Geldig t/m'
  },
  user_data: 'Gebruikersgegevens',
  user_report: 'Gebruikersrapport',
  user: 'Gebruiker',
  viewer: 'Teamviewer',
  website: 'Website',
  welcome_back: 'Welkom terug',
  welcome_to_update: 'Welkom bij Update',
  whether_youve_completed_a_test: `PA status voor het specifieke profiel`,
  which_tests_are_completed: 'Overall PA status',
  yes: 'Ja',
  help_and_support: 'Help & Ondersteuning',
  faq: 'FAQ',
  frequently_asked_questions: 'Veel Gestelde Vragen',
  no_results: 'Geen resultaten',
  optional: 'Optioneel',
  management: 'Beheer',
  no_themes_under_this_profile: `Geen thema's onder dit profiel`,
  article_filters: 'Artikelfilters',
  article_status: 'Artikelstatus',
  article_status_temp: 'Nieuwe artikelstatus update',
  article_type: 'Artikeltype',
  load_more_articles: 'Meer artikelen laden',
  manage_profiles: 'Profielen beheren',
  my_themes: `Mijn thema's`,
  submit: 'Toepassen',
  clear: 'Wissen',
  no_unread_articles: 'Geen ongelezen artikelen',
  no_completed_articles: 'Geen behaalde artikelen',
  no_in_progress_articles: 'Geen artikelen in uitvoering',
  you_cannot_edit_this_employee: 'U kunt deze medewerker niet bewerken.',
  user_dashboard_tabs: {
    pa_feature: 'Permanent Actueel',
    competencies: 'Adviesbevoegdheden',
    certificates: 'Certificaten',
    qualifications: 'Kwalificaties',
    exam_bookings: 'Geboekte examens',
    articles: 'Overzicht van alle artikelen',
    all_packages_disabled: 'Alle pakketten zijn uitgeschakeld',
  },
  // #endregion

  // #region key'd strings
  account_error__account_expired_text:
    'Je account is verlopen. Als u denkt dat dit een fout is, neem dan contact op met uw beheerder.',
  account_setup__privacy_policy__explanation_text: `Hieronder vindt u het privacybeleid van deze applicatie. U moet dit privacybeleid accepteren om deze applicatie te gebruiken.`,
  account_setup__start_card__explanation_text:
    'Welkom bij Update. Voordat u deze applicatie kunt gebruiken, moet u uw account instellen. Selecteer uw taal en klik op de onderstaande knop om te beginnen.',
  account_setup__terms_and_conditions__explanation_text: `Hieronder vindt u de voorwaarden van deze applicatie. U moet deze voorwaarden accepteren om deze applicatie te gebruiken.`,
  add_lti_data__explanation_text: `Deze gegevens zijn nodig voor een bedrijfsspecifieke bundel van SkillsTown. Dit is niet nodig voor artikelen van NIBE-SVV.`,
  article_create__lti_explanation_message: `Om een artikel aan te maken heb je eerst de LTI Identifier nodig, deze kan je aanmaken in SkillsTown. Een artikel inhoudelijk aanpassen kan hier ook gedaan worden. Klik op 'Open SkillsTown' om een LTI Identifier te krijgen of een artikel aan te passen.`,
  article_detail__test_passed_message:
    'U hebt de test die bij dit artikel hoort eerder voltooid en behaald.',


  terms_and_conditions__documents_explainer_text:
    'Deze documenten regelen uw gebruik van deze applicatie en onze verplichtingen met betrekking tot hoe wij uw gegevens verwerken.',
  profiles__add_themes_explanation_text: `Druk eerst op profiel aanmaken om vervolgens thema's toe te voegen.`,
  admin_reports__excel_report_explanation_text:
    'Download hier een rapportage voor een handig overzicht van de PA-statussen van jouw teams en medewerkers.',
  admin_reports__user_report_explanation_text: 'Download een Excel-rapport met gebruikersgegevens.',
  user_dashboard__overall_pa_status__text_red:
    'Je bent niet meer Aantoonbaar Actueel. Lees de artikelen om Aantoonbaar Actueel te zijn.',
  user_dashboard__overall_pa_status__text_orange:
    'Je bent nog Aantoonbaar Actueel! Let op, blijf up-to-date met de laatste artikelen om dit te behouden.',
  user_dashboard__overall_pa_status__text_green: 'Helemaal goed, je bent nu Aantoonbaar Actueel!',
  user_dashboard__overall_pa_status__text_default: 'PA status onbekend',
  support__email_card_title: 'Heb je een dringende vraag aan NIBE-SVV?',
  support__email_card_text: `Gebruik je Wft Triple A om je PA status te behouden en heb je een vraag over de nieuwe
  omgeving, kan je iets nog niet vinden? Laat dit ons weten via onderstaand mailadres:`,
  support__account_manager_card_title: 'Maak je gebruik van de omgeving als manager?',
  support__account_manager_card_text: `En kan je een rapportage niet vinden of heb je hier hulp bij nodig?  Neem dan contact op met Projectbureau NIBE-SVV via onderstand mailadres: `,
  support__faq_card_text__without_link: `Als u op zoek bent naar antwoorden op veelgestelde vragen,`,
  support__faq_card_text___link: `kunt u hier onze veelgestelde vragen bekijken.`,
  dashboard_articles_notice__title: 'Op deze pagina vind je alle beschikbare artikelen:',
  dashboard_articles_notice__first_paragraph: `De status van de artikelen is gebaseerd op jouw activiteiten binnen deze (nieuwe) omgeving. Let op: artikelen die je mogelijk eerder gelezen hebt in een andere omgeving staan hier als "ongelezen" vermeld.`,
  dashboard_articles_notice__second_paragraph: `Via het Dashboard (aan de linker bovenzijde) vind je de artikelen die betrekking hebben op jouw - verplichte - deskundigheid. Let op: hier is wel rekening gehouden met eerder behaalde resultaten in een andere omgeving.`,
  dashboard_empty_state_title: `Stel uw omgeving in`,
  dashboard_empty_state_text: `Op dit moment heb je geen optionele profielen of thema's ingesteld voor jouw account. Onder Beheer > Profielen beheren heb je de mogelijkheid om in te schrijven op optionele profielen of thema's.`,
  dashboard_article_status_notification_first_paragraph: `Jouw artikelstatus wordt bijgewerkt na het doorlopen van alle pagina's in het artikel én het afronden van de toets.`,
  dashboard_article_status_notification_second_paragraph: `Heb je de toets gemaakt, maar niet alle pagina's doorlopen, dan kun je terug naar het artikel onder in uitvoering en de resterende pagina's van het artikel doorlopen. Vervolgens zal jouw artikelstatus automatisch worden aangepast naar behaald, de toets hoef je niet opnieuw af te leggen.`,
  scheduled_maintenance: 'Gepland onderhoud - Update',
  dashboard_article_status_issues_notification_first_paragraph:
    'Zoals eerder aangekondigd: In de periode 1 juli tot en met 3 juli worden er verschillende updates en aanpassingen uitgevoerd.</br>Hierdoor kan het voorkomen dat wijzigingen in jouw artikelstatus of PA-status met een vertraging worden verwerkt.',
  dashboard_article_status_issues_notification_second_paragraph:
    'Omdat de laatste aanpassing een grotere impact heeft op de bruikbaarheid van de applicatie, voeren wij de laatste aanpassingen uit op 4 juli 2024 tussen 19:00 - 21:00 en is de applicatie op dat moment tijdelijk niet (goed) beschikbaar of toegankelijk.',
  // #endregion

  pagination: {
    next: 'Volgende',
    previous: 'Vorige',
    exam: 'Toets',
    result: 'Toetsresultaten',
  },

  answer_description_invalid: 'Antwoord toelichting mag niet langer zijn dan 5000 tekens.',
  content_chapter_final_test_missing: 'Afrondende toetsing ontbreekt.',
  missing_value: 'Dit veld kan niet leeggelaten worden.',
  one_or_more_validation_errors_occured: 'Een of meer validaties zijn niet geslaagd.',
  number_of_questions_incorrect: 'De waarde moet een heel getal zijn tussen 1 en het aantal vragen in deze toets.',
  passing_score_format_incorrect: 'De waarde moet een getal zijn.',
  passing_score_incorrect: 'De waarde moet tussen 0 en 100 liggen.',
  question_answers_missing: 'Minimaal 2 antwoorden zijn vereist.',
  question_correct_answers_invalid_number: 'Er mag maar 1 juist antwoord geselecteerd zijn',
  test_questions_missing: 'Er moet minimaal 1 vraag zijn in de test.',
  sidebar: {
    titles: {
      general: 'Algemeen',
      pa: 'PA',
      pe: 'PE'
    },
    pages: {
      competencies: 'Adviesbevoegdheden',
      modules: 'Modules',
      exam_bookings: 'Examen boekingen',
      certificates: 'Certificaten',
      qualifications: 'Kwalificaties'
    }
  },
  page_not_found: 'Pagina niet gevonden.',
  page_forbidden: 'U hebt geen toestemming om deze pagina te bekijken.',
  data_forbidden: 'Je hebt niet de vereiste toegangsrechten om deze informatie te bekijken.',
  forbidden: 'Verboden',
  account_disabled: 'Uw account is gedeactiveerd. Neem contact op met uw beheerder voor meer informatie.',
  login_again: 'Log opnieuw in',
  additional_data: 'Extra informatie',
  readonly_admin: 'Alleen-lezen beheerder'
};
